import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['toggle']

  initialize() {
    this._collapsibleToggle = this.collapsibleToggle.bind(this)
  }

  collapsibleToggle(event) {
    this.openCloseCollapsible(event)
  }

  openCloseCollapsible(event) {
    this.element.classList.toggle('collapsible--open')
  }

  connect() {
    this.toggleTarget.addEventListener('click', this._collapsibleToggle)
  }

  disconnect() {
    this.toggleTarget.removeEventListener('click', this._collapsibleToggle)
  }
}
